// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rKlWy283ri4xwHL8Kn_g {
  color: var(--keyword-color);
  align-content: center;
  background-color: var(--dk-grey-color);
  width: 100%;
  display: flex;
}

.GNHz4Z32tCb3NWnvnPTe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.Am05K9qnptEDfuMjHQgO {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  justify-content: space-between;
}

.Am05K9qnptEDfuMjHQgO h1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--step-0);
  margin: 0 0.5rem;
}

.DspJv1Ujz5YalT2g1geN {
  margin-left: 1rem;
  max-width: 80%;
  display: flex;
  align-items: center;
}

.iaiP3_f6OcSeYBydcqz_ {
  width: 100%;
}

.zjrYw_irQwAXqA8MzBjA,
._pqor9BtrSFMAySIAdjS {
  border: solid 2px;
  height: 2.1rem;
  display: flex;
  justify-content: space-between;
  border-radius: 0.25em;
  margin-bottom: 1rem;
}

.zjrYw_irQwAXqA8MzBjA {
  border-color: var(--place-color);
}

._pqor9BtrSFMAySIAdjS {
  border-color: var(--date-color);
}

.NHa6VjeOOyApry6a0dgs {
  display: flex;
  align-items: center;
  width: 80%;
}

.qbxSOG1ff6EPr4b5jamO {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: var(--step-2);
  color: var(--white-color);
  padding: var(--space-s) var(--space-xs);
  border: 0;
  outline: 0;
  background-color: transparent;
  margin-right: 1rem;
  cursor: pointer;
  transition: var(--global-nav-transition);
}

.qbxSOG1ff6EPr4b5jamO.OcCSgOhEMdh1OwNlX6od {
  opacity: 0;
  pointer-events: none;
}

.pJo4kDjpuNPn3eQXLvjx {
  border-top: 3px dashed var(--white-color);
  background-color: var(--dk-grey-color);
  display: none;
  position: sticky;
  justify-content: right;
  align-items: center;
  padding: 1rem 2rem 1rem 0;
}

.pJo4kDjpuNPn3eQXLvjx.TWMW_wLBZy0JaAIrQ4yo {
  display: flex;
  justify-content: center;
  transition: var(--global-nav-transition);
}

.pJo4kDjpuNPn3eQXLvjx a {
  color: var(--white-color);
  padding: var(--space-xs) var(--space-s);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.Oo7Xk3hGEhfWfdRtXPgJ,
.NwAthg91c4Ff9Y3RAEgV,
.vhOF2rh00ZSGn1l_ML1o {
  background-color: transparent;
  border: none;
  font-size: var(--step--1);
  font-weight: 600;
}

.Oo7Xk3hGEhfWfdRtXPgJ {
  color: var(--white-color);
  display: flex;
  align-items: center;
  padding-left: 1rem;
}

.NwAthg91c4Ff9Y3RAEgV,
.vhOF2rh00ZSGn1l_ML1o {
  padding-right: 2rem;
}

.NwAthg91c4Ff9Y3RAEgV {
  color: var(--place-color);
}

.vhOF2rh00ZSGn1l_ML1o {
  color: var(--date-color);
}

.zjoeo6athXipGrw9UcJX {
  display: flex;
  align-items: center;
  padding: 0 1rem;
}

.d8QUs9V3IvzwIQgSxPUa {
  padding-right: 1rem;
}

.XEOCMHDKbi9bmrdognKT {
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0;
  outline: 0;
}

.cXHbOBeoXx17H_WqnCh_ {
  display: flex;
  align-items: center;
  padding-left: 1rem;
  color: var(--white-color);
  font-size: var(--step--1);
}

.v_9CagqIg4za9txFNHlR {
  display: inline-block;
  width: 100%;
  overflow-wrap: break-word;
  font-size: var(--step--1);
  color: var(--white-color);
}

.Ttt2JeZZ1IHz4q6QZziB {
  color: var(--date-color);
  font-weight: bold;
  padding-inline: 0.1rem;
}

.AdN_ALEzfXGoKViUC12F {
  font-size: var(--step--1);
  font-weight: 500;
}

.vzvygZR2TrKh3v4s6qq6,
.cavQN1tLrusPgROsNGV1,
.Ttt2JeZZ1IHz4q6QZziB {
  font-weight: bold;
}

.vzvygZR2TrKh3v4s6qq6 {
  color: var(--place-color);
  padding-left: 0.1rem;
}

.cavQN1tLrusPgROsNGV1 {
  color: var(--place-color);
  padding-left: 0.5rem;
}

.Ttt2JeZZ1IHz4q6QZziB {
  color: var(--date-color);
  padding-inline: 0.5rem;
}

.Oo7Xk3hGEhfWfdRtXPgJ:hover {
  color: var(--white-color);
  opacity: 50%;
}

.NwAthg91c4Ff9Y3RAEgV:hover,
.vhOF2rh00ZSGn1l_ML1o:hover {
  opacity: 50%;
  color: var(--white-color);
}

.qbxSOG1ff6EPr4b5jamO:hover,
.zjoeo6athXipGrw9UcJX:hover {
  opacity: 50%;
}

.zJTbHEF8p_ScQXsAC1nd:hover {
  color: var(--white-color);
}

.gFNzyC2_f_7UVF7vID6O::before {
  content: "\\f133";
  color: var(--date-color);
}

.Hlrkc0v8ywAqKwWLJ2Dv,
.TBzBGEpDrW4vLkY4UrxE,
.gFNzyC2_f_7UVF7vID6O,
.Gc7xsQ8xiwAgUDLYJVmM,
._E0ZDbfFZ4PVPNOTZ1Iw {
  font-size: 22px;
  padding-inline: 1.5rem;
}

.Hlrkc0v8ywAqKwWLJ2Dv::before,
.TBzBGEpDrW4vLkY4UrxE::before,
.gFNzyC2_f_7UVF7vID6O::before,
.Gc7xsQ8xiwAgUDLYJVmM::before,
._E0ZDbfFZ4PVPNOTZ1Iw::before {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResultPage/components/ResultsHeader.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,sCAAsC;EACtC,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,uCAAuC;EACvC,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;;;EAKE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;;;EAKE,kCAAkC;EAClC,gBAAgB;AAClB","sourcesContent":[".container {\n  color: var(--keyword-color);\n  align-content: center;\n  background-color: var(--dk-grey-color);\n  width: 100%;\n  display: flex;\n}\n\n.containerContent {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n}\n\n.headerRowOne {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.headerRowOne h1 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--step-0);\n  margin: 0 0.5rem;\n}\n\n.headerTitle {\n  margin-left: 1rem;\n  max-width: 80%;\n  display: flex;\n  align-items: center;\n}\n\n.headerRowTwo {\n  width: 100%;\n}\n\n.locationLink,\n.dateLink {\n  border: solid 2px;\n  height: 2.1rem;\n  display: flex;\n  justify-content: space-between;\n  border-radius: 0.25em;\n  margin-bottom: 1rem;\n}\n\n.locationLink {\n  border-color: var(--place-color);\n}\n\n.dateLink {\n  border-color: var(--date-color);\n}\n\n.dateLinkInfo {\n  display: flex;\n  align-items: center;\n  width: 80%;\n}\n\n.resultNavButton {\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--step-2);\n  color: var(--white-color);\n  padding: var(--space-s) var(--space-xs);\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  margin-right: 1rem;\n  cursor: pointer;\n  transition: var(--global-nav-transition);\n}\n\n.resultNavButton.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.subNav {\n  border-top: 3px dashed var(--white-color);\n  background-color: var(--dk-grey-color);\n  display: none;\n  position: sticky;\n  justify-content: right;\n  align-items: center;\n  padding: 1rem 2rem 1rem 0;\n}\n\n.subNav.open {\n  display: flex;\n  justify-content: center;\n  transition: var(--global-nav-transition);\n}\n\n.subNav a {\n  color: var(--white-color);\n  padding: var(--space-xs) var(--space-s);\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.customLocationLink,\n.closeButton,\n.closeButtonDate {\n  background-color: transparent;\n  border: none;\n  font-size: var(--step--1);\n  font-weight: 600;\n}\n\n.customLocationLink {\n  color: var(--white-color);\n  display: flex;\n  align-items: center;\n  padding-left: 1rem;\n}\n\n.closeButton,\n.closeButtonDate {\n  padding-right: 2rem;\n}\n\n.closeButton {\n  color: var(--place-color);\n}\n\n.closeButtonDate {\n  color: var(--date-color);\n}\n\n.graphButton {\n  display: flex;\n  align-items: center;\n  padding: 0 1rem;\n}\n\n.locationIconWrapper {\n  padding-right: 1rem;\n}\n\n.iconButton {\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n}\n\n.zipText {\n  display: flex;\n  align-items: center;\n  padding-left: 1rem;\n  color: var(--white-color);\n  font-size: var(--step--1);\n}\n\n.dateTextContainer {\n  display: inline-block;\n  width: 100%;\n  overflow-wrap: break-word;\n  font-size: var(--step--1);\n  color: var(--white-color);\n}\n\n.displayTextDate {\n  color: var(--date-color);\n  font-weight: bold;\n  padding-inline: 0.1rem;\n}\n\n.locationText {\n  font-size: var(--step--1);\n  font-weight: 500;\n}\n\n.displayText,\n.displayTextZip,\n.displayTextDate {\n  font-weight: bold;\n}\n\n.displayText {\n  color: var(--place-color);\n  padding-left: 0.1rem;\n}\n\n.displayTextZip {\n  color: var(--place-color);\n  padding-left: 0.5rem;\n}\n\n.displayTextDate {\n  color: var(--date-color);\n  padding-inline: 0.5rem;\n}\n\n.customLocationLink:hover {\n  color: var(--white-color);\n  opacity: 50%;\n}\n\n.closeButton:hover,\n.closeButtonDate:hover {\n  opacity: 50%;\n  color: var(--white-color);\n}\n\n.resultNavButton:hover,\n.graphButton:hover {\n  opacity: 50%;\n}\n\n.icon:hover {\n  color: var(--white-color);\n}\n\n.date::before {\n  content: \"\\f133\";\n  color: var(--date-color);\n}\n\n.location,\n.distance,\n.date,\n.more,\n.timestamp {\n  font-size: 22px;\n  padding-inline: 1.5rem;\n}\n\n.location::before,\n.distance::before,\n.date::before,\n.more::before,\n.timestamp::before {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `rKlWy283ri4xwHL8Kn_g`,
	"containerContent": `GNHz4Z32tCb3NWnvnPTe`,
	"headerRowOne": `Am05K9qnptEDfuMjHQgO`,
	"headerTitle": `DspJv1Ujz5YalT2g1geN`,
	"headerRowTwo": `iaiP3_f6OcSeYBydcqz_`,
	"locationLink": `zjrYw_irQwAXqA8MzBjA`,
	"dateLink": `_pqor9BtrSFMAySIAdjS`,
	"dateLinkInfo": `NHa6VjeOOyApry6a0dgs`,
	"resultNavButton": `qbxSOG1ff6EPr4b5jamO`,
	"hidden": `OcCSgOhEMdh1OwNlX6od`,
	"subNav": `pJo4kDjpuNPn3eQXLvjx`,
	"open": `TWMW_wLBZy0JaAIrQ4yo`,
	"customLocationLink": `Oo7Xk3hGEhfWfdRtXPgJ`,
	"closeButton": `NwAthg91c4Ff9Y3RAEgV`,
	"closeButtonDate": `vhOF2rh00ZSGn1l_ML1o`,
	"graphButton": `zjoeo6athXipGrw9UcJX`,
	"locationIconWrapper": `d8QUs9V3IvzwIQgSxPUa`,
	"iconButton": `XEOCMHDKbi9bmrdognKT`,
	"zipText": `cXHbOBeoXx17H_WqnCh_`,
	"dateTextContainer": `v_9CagqIg4za9txFNHlR`,
	"displayTextDate": `Ttt2JeZZ1IHz4q6QZziB`,
	"locationText": `AdN_ALEzfXGoKViUC12F`,
	"displayText": `vzvygZR2TrKh3v4s6qq6`,
	"displayTextZip": `cavQN1tLrusPgROsNGV1`,
	"icon": `zJTbHEF8p_ScQXsAC1nd`,
	"date": `gFNzyC2_f_7UVF7vID6O`,
	"location": `Hlrkc0v8ywAqKwWLJ2Dv`,
	"distance": `TBzBGEpDrW4vLkY4UrxE`,
	"more": `Gc7xsQ8xiwAgUDLYJVmM`,
	"timestamp": `_E0ZDbfFZ4PVPNOTZ1Iw`
};
export default ___CSS_LOADER_EXPORT___;
